import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { reportPerformance } from './utils/performance';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

// Immediate render for faster startup
root.render(<App />);

// Report performance after load
reportPerformance();
